import { api } from '../api/client';

export type DocumentationSlug = 'user' | 'developers';

type DocumentationOpenToken = {
  slug: DocumentationSlug;
  path: string;
  token: string;
};

export function documentationPagePath(slug: DocumentationSlug): string {
  return `/documentation/${slug}`;
}

export async function openDocumentationPage(slug: DocumentationSlug): Promise<void> {
  const tab = window.open('about:blank', '_blank');
  if (tab) {
    tab.opener = null;
    tab.document.title = 'MP Trend documentation';
    tab.document.body.textContent = 'Загружаем документацию...';
  }

  try {
    const ticket = await api.post<DocumentationOpenToken>('/api/docs/open-token', { slug });
    const url = `${window.location.origin}${ticket.path}#token=${encodeURIComponent(ticket.token)}`;
    if (tab) {
      tab.location.replace(url);
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch (err) {
    if (tab) tab.close();
    throw err;
  }
}
